var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12254_606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9583 6.02205L12.4224 0.884302C12.1531 0.33927 11.608 0 11.0002 0C10.3923 0 9.84649 0.33927 9.57712 0.884302L7.03024 6.03069L1.36003 6.85452C0.757664 6.94169 0.266822 7.35557 0.0791234 7.93437C-0.10936 8.51239 0.0445682 9.13595 0.480436 9.56083L4.58781 13.574L3.61947 19.2214C3.51659 19.8206 3.75848 20.4159 4.25011 20.7732C4.52812 20.9751 4.85325 21.078 5.18074 21.078C5.43284 21.078 5.68651 21.0167 5.92054 20.8942L11.0072 18.2279L16.079 20.8942C16.6178 21.1769 17.2578 21.1314 17.7495 20.7732C18.2411 20.4159 18.4838 19.8214 18.3809 19.2214L17.4165 13.5606L21.5199 9.56083C21.9558 9.13595 22.1089 8.51317 21.9212 7.93437C21.7335 7.35557 21.2427 6.94169 20.6403 6.85452L14.9701 6.03069L14.9583 6.02205Z",
    fill: "#4A4A65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12254_606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2);
export default __webpack_public_path__ + "static/media/a2.dba454a4de832d9374bb694b2ee4f065.svg";
export { ForwardRef as ReactComponent };